var voted_users_rtlignore_default = {
  "container": "Gnwxw",
  "webview": "n-4-H",
  "avatar_list": "_8eOBC",
  "avatar": "vOs7S",
  "user_avatar": "d459U",
  "modal": "_7hBph",
  "voted_users_modal": "_5gjU-",
  "overlay": "MQ4rI",
  "user_card": "G7CWo",
  "user_name": "uP85P",
  "voted_users_modal_header": "GHU0d",
  "cta": "kC3Ka",
  "close_icon": "eBOgR",
  "title": "j7k-t",
  "member_list_container": "pM6dU",
  "member_list": "_7hOSS",
  "loader": "C75ch",
  "anonymous_counter": "aJrmt",
  "spinner": "_43Rup",
  "spin": "lfM2e"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
